module.exports = __webpack_public_path__ + "img/contactmap.e849383e.jpg";